import {Directive, Input, TemplateRef, ViewContainerRef} from '@angular/core';
import { PermissionsHelperService } from 'src/app/services/permissions-helper/permissions-helper.service';
import { PermissionTypes } from '../../model/enum/permission-types.enum';
import { ArraysHelper } from 'src/app/model/helpers/arrays/arrays.helpers';
import { StructuralDirectiveHelpersService } from '@edl-development/edl-common';

@Directive({
    selector: '[permissionsAll]'
})
export class PermissionsAllDirective {
    @Input() set permissionsAll(value: PermissionTypes[]) {
        this.structuralDirectiveHelpersService.showOrHideElement<PermissionTypes[]>({
            hasBeenInitialized: this.hasBeenInitialized,
            previousValue: this._permissionsAll,
            newValue: value, 
            viewContainer: this.viewContainer, 
            templateRef: this.templateRef, 
            shouldShow: this.permissionsHelperService.doIHaveAllPermissions,
            isEqual: ArraysHelper.areListsEqual
        });
        
        this._permissionsAll = value;
        this.hasBeenInitialized = true;
    }

    private _permissionsAll: PermissionTypes[] = [];
    private hasBeenInitialized: boolean = false;

    constructor(
        private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef,
        private permissionsHelperService: PermissionsHelperService,
        private structuralDirectiveHelpersService: StructuralDirectiveHelpersService
    ) {}
}